export default __webpack_public_path__ + "static/media/tiber-river-g1564ce926_1920.6ce527d4.jpg";